import React from 'react';
import { useTheme } from 'styled-components';
import { IconProps } from './types';

/** @deprecated Use icons from '@sighten/beacon/icons' instead */
export function ChevronRight({ color }: IconProps) {
  const theme = useTheme();

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="10" height="16" viewBox="0 0 10 16" fill="none">
      <path
        d="M9.1505 7.48622C9.4324 7.76812 9.4324 8.23188 9.1505 8.51378L1.87571 15.7886C1.59381 16.0705 1.13004 16.0705 0.848142 15.7886C0.566244 15.5067 0.566244 15.0429 0.848142 14.761L7.60915 8L0.848142 1.23899C0.566244 0.95709 0.566244 0.493322 0.848142 0.211424C1.13004 -0.0704746 1.59381 -0.0704746 1.87571 0.211424L9.1505 7.48622Z"
        fill={color || theme.colors.iconIconPrimaryPressedSecondary2100}
      />
    </svg>
  );
}

export default ChevronRight;
